import { createMatchMediaConnect } from 'react-matchmedia-connect'
import forEachObjIndexed from 'ramda/src/forEachObjIndexed'

export const mediaQueries = breakpoints => {
  let mqlist = {}

  forEachObjIndexed((value, key) => {
    const mq = {}
    mq[`isMin${key.charAt(0).toUpperCase()}${key.slice(1)}`] = `(min-width: ${value}px)`
    mq[`isMax${key.charAt(0).toUpperCase()}${key.slice(1)}`] = `(max-width: ${value}px)`

    mqlist = {
      ...mqlist,
      ...mq,
    }
  }, breakpoints)

  return mqlist
}

export const BASE_BREAKPOINTS = {
  xs: 360,
  sm: 640,
  md: 768,
  lg: 1024,
}

export const SIDE_BREAKPOINTS = {
  xsMinus: BASE_BREAKPOINTS.xs - 1,
  xsPlus: BASE_BREAKPOINTS.xs + 1,

  smMinus: BASE_BREAKPOINTS.sm - 1,
  smPlus: BASE_BREAKPOINTS.sm + 1,

  mdMinus: BASE_BREAKPOINTS.md - 1,
  mdPlus: BASE_BREAKPOINTS.md + 1,

  lgMinus: BASE_BREAKPOINTS.lg - 1,
  lgPlus: BASE_BREAKPOINTS.lg + 1,
}

export const RESPONSIVE_BREAKPOINTS = {
  ...SIDE_BREAKPOINTS,
  ...BASE_BREAKPOINTS,
}

export const MEDIA_QUERIES = mediaQueries(RESPONSIVE_BREAKPOINTS)

export const withResponsiveFactory = () => {
  if (typeof window !== 'undefined') {
    return createMatchMediaConnect(MEDIA_QUERIES)
  }
  return () => wrappedComponent => wrappedComponent
}
